<template>
  <div>
      <div style="width:100%;height:300px;margin:auto;">
        <video width="100%" height="240" controls style="background:#000">
          <source :src="videoUrl" type="video/mp4">
        </video>
    </div>
  </div>
</template>

<script>
import wx from 'weixin-js-sdk'
// import LivePlayer from '@liveqing/liveplayer'
export default {
  data() {
    return {
       videoUrl:'',
    }
  },
  created() {
    let params = this.$route.query;
    if(params&&params.url){
     this.videoUrl  = params.url; 
    }
  
  },
  mounted() {},
  methods: {
  },
}
</script>

<style lang="less" scoped>
.flex-col-center {
  display: flex;
  flex-direction: column;
  align-items: center;
}
/*说明*/
.tips {
  font-size: 20px;
  color: #333333;
  margin-top: 20px;
  font-weight: 400;
}
.desc {
  font-size: 15px;
  color: #666666;
  margin-top: 14px;
  font-weight: 400;
}

</style>
